import canUseDom from 'dw-neit-rc-util/lib/Dom/canUseDom';
import { isStyleSupport } from 'dw-neit-rc-util/lib/Dom/styleChecker';
export const canUseDocElement = () => canUseDom() && window.document.documentElement;
export { isStyleSupport };
